/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
//utils
import { browserAlertOn, browserAlertOff } from 'utils/embeds/browser_alert';
// nav
import Nav from 'material/nav/nav';
import NavItem from 'material/nav/navitem/navitem';
import Link from 'material/ctas/link/link_container';
// sections
import Settings from 'pages/dashboard/reports/detail/settings/settings_container';
import Dimensions from 'pages/dashboard/reports/detail/dimensions/dimensions_container';
import Metrics from 'pages/dashboard/reports/detail/metrics/metrics_container';
import Filters from 'pages/dashboard/reports/detail/filters/filters_container';
import Schedule from 'pages/dashboard/reports/detail/schedule/schedule_container';
// header
import ReportHelpers from 'pages/dashboard/reports/reporthelpers/reporthelpers';
// footer
import ReportControls from 'pages/dashboard/reports/reportcontrols/reportcontrols_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/detail_styles';


/* ========== ~~~~~~~~~~ PAGE : REPORTS : DETAIL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class DetailPage extends Component {
	constructor(props) {
		super(props);
		this.sections = [
			{ id: 'settings', text: 'Report Settings', component: <Settings /> },
			{ id: 'dimensions', text: 'Dimensions', component: <Dimensions /> },
			{ id: 'metrics', text: 'Metrics', component: <Metrics /> },
			{ id: 'filters', text: 'Filters', component: <Filters /> },
			{ id: 'schedule', text: 'Schedule', component: <Schedule /> }
		];
		this.state = { activeSection: null };
	}

	componentDidMount() {
		this.setState({activeSection: this.sections[0].id}, window.addEventListener('scroll', this.onWindowScroll));
		if(this.props.reportChangeDetected) this.turnEditStateAlertsOn();
	}

    componentDidUpdate(prevProps) {
        if (this.props.reportChangeDetected && !prevProps.reportChangeDetected)
            this.turnEditStateAlertsOn();
        else if (!this.props.reportChangeDetected && prevProps.reportChangeDetected)
            this.turnEditStateAlertsOff();
    }

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onWindowScroll);
		this.turnEditStateAlertsOff();
	}

	turnEditStateAlertsOn = () => {
        browserAlertOn();
        this.props.setEditMode(true);
    };

    turnEditStateAlertsOff = () => {
        browserAlertOff();
        this.props.setEditMode(false);
	};

	onWindowScroll = () => {
		this.sections.forEach(section => this.setActiveSelection(section, this[section.id]));
	};

	setActiveSelection = (sectionData, sectionEl) => {
		const bounding = sectionEl.getBoundingClientRect();
		if (bounding.top >= 0 && window.scrollY - this[sectionData.id].offsetTop >= -window.innerHeight*0.05
		&& bounding.right <= (window.innerWidth || document.documentElement.clientWidth)) {
			this.setState({ activeSection: sectionData.id });
		}
	};

	handleSectionValidityCheck = (data) => {
		let scheduleValid = true;
		if(!data.schedule.length || !data.endDate) {
			scheduleValid = false;
		}
		if(data.emails) {
			scheduleValid = this.handleEmailValidityCheck(scheduleValid, data.emails);
		}

		this.props.setReportProperties({selectedReportDataValid: Object.assign({},this.props.selectedReportData.selectedReportDataValid, {schedule: scheduleValid})});
		return scheduleValid;
	};

	handleEmailValidityCheck = (scheduleValid, emails) => {
		emails.forEach((item) => {
			item.valid = !!item.valid;
			if(!item.valid) {
				scheduleValid = false;
				item.valid = !!item.valid;
			}
		});
		this.props.setReportProperties({emails: emails});
		return scheduleValid;
	};

	// Need to refine this going further. For now it's working.
	navigateInvalid = () => {
		if(this.props.selectedReportStatus.status.isReportSaved !== true) {
			for (let section of this.sections) {
				if ((section.id === 'schedule' && !this.handleSectionValidityCheck(this.props.selectedReportData)) ||
					((section.id !== 'settings' || section.id !== 'schedule') && this.props.selectedReportData.selectedReportDataValid[section.id] === false) ||
					(section.id === 'settings' && this.props.selectedReportData.name === "")) {
					if (section.id === 'settings') {
						this.props.setReportProperties({selectedReportDataValid: Object.assign({}, this.props.selectedReportData.selectedReportDataValid, {settings: false})})
					}
					window.scrollTo(0, this[section.id].offsetTop);
					this.setState({activeSection: section.id});
					return false;
				}
			}
		}
		return true;
	};

	render() {
		return (
			<Page name={`detail`} klass={`${this.props.classes.detail} processing-${this.props.processing}`}>
				<Content>
					<ReportHelpers />
					<div className={`areacontent`}>
						<div className={`areanav`}>
							<Nav variant={`intrapage`}>
								{this.sections.map(section => <NavItem key={section.id}><Link type={`scroll`} name={section.id} text={section.text} action={this[section.id]} activeSection={this.state.activeSection} /></NavItem>)}
							</Nav>
						</div>
						<div className={`areasections`}>
							{this.sections.map(section => <section key={section.id} id={section.id} ref={(el) => { this[section.id] = el; }}>{section.component}</section>)}
						</div>
					</div>
				</Content>
				<ReportControls variant={'detail'} navigateInvalid={this.navigateInvalid} />
			</Page>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(DetailPage);
